import { personas } from './persona';

/**
 * DocumentStrategy resolves section prioritization, layout slot distribution,
 * and column reflowing based on user persona and layout choice.
 */
export function resolveDocumentStrategy({ resumeData, activeSections, personaId, layoutId, templateLayoutConfig, templateConfig }) {
  // 1. Resolve active persona priority / custom user ordering
  const persona = personas[personaId] || personas['engineering'];
  const userOrder = Array.isArray(resumeData?.sections)
    ? resumeData.sections.map(k => k === 'contact' ? 'personal-info' : k)
    : null;
  const orderedSections = userOrder && userOrder.length > 0
    ? [...userOrder]
    : (templateConfig?.sectionOrder || [...persona.sectionOrder]);

  // Map any additional sections not specified in the list to the end
  activeSections.forEach(section => {
    if (!orderedSections.includes(section) && section !== 'personalInfo') {
      orderedSections.push(section);
    }
  });

  // 2. Identify target layout slot structure
  const slots = {
    header: [],
    main: [],
    sidebar: [],
    footer: []
  };

  // If the template supports specific slot mappings for this layout
  if (templateLayoutConfig && templateLayoutConfig.slots) {
    const layoutSlots = templateLayoutConfig.slots;

    // Distribute according to layout config slots (do not filter out core identity/contact components)
    const isCoreComponent = (s) => s === 'personal-info' || s === 'contact-sidebar';
    if (layoutSlots.header) slots.header = layoutSlots.header.filter(s => activeSections.includes(s) || isCoreComponent(s));
    if (layoutSlots.main) slots.main = layoutSlots.main.filter(s => activeSections.includes(s) || isCoreComponent(s));
    if (layoutSlots.sidebar) slots.sidebar = layoutSlots.sidebar.filter(s => activeSections.includes(s) || isCoreComponent(s));
    if (layoutSlots.footer) slots.footer = layoutSlots.footer.filter(s => activeSections.includes(s) || isCoreComponent(s));

    // Ensure all active sections are routed somewhere!
    activeSections.forEach(section => {
      const isRouted = slots.header.includes(section) || 
                       slots.main.includes(section) || 
                       slots.sidebar.includes(section) || 
                       slots.footer.includes(section) ||
                       section === 'contact';
      if (!isRouted) {
        slots.main.push(section);
      }
    });

    // Reflow logic for layouts that do NOT have a sidebar slot (e.g. single-column)
    const isSingleColumn = layoutId === 'single-column';
    if (isSingleColumn && slots.sidebar.length > 0) {
      // Fold sidebar elements into main
      slots.main = [...slots.main, ...slots.sidebar];
      slots.sidebar = [];
    }
  } else {
    // Fallback default routing (single-column priority)
    slots.header = ['personal-info'];
    slots.main = orderedSections.filter(s => s !== 'personal-info');
  }

  // Map section components by order
  slots.main.sort((a, b) => orderedSections.indexOf(a) - orderedSections.indexOf(b));
  if (slots.sidebar.length > 0) {
    slots.sidebar.sort((a, b) => orderedSections.indexOf(a) - orderedSections.indexOf(b));
  }

  return slots;
}
